import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

/** Loading placeholder. Uses a gentle pulse (reduced-motion collapses it via the
 *  global guard in index.css). Reserve the real content's box to avoid layout shift. */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-muted', className)} {...props} />;
}
